import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { Box, Text } from 'rebass'
import * as yup from 'yup'
import { useNewTranslation } from 'hooks/index'
import Button from 'components/Shared/Button/OldButton'
import Inputs from 'components/Inputs'
import { theme } from 'theme'

interface NoneApproveFormValues {
    comment: string | null
}

// TODO: handle cleanup for all tag reject or edit change
interface RejectionFromProps {
    handleCancel: any
    handleReject: any
    handleRejectTagChange: any
}

const RejectionForm: React.FC<RejectionFromProps> = ({ handleCancel, handleReject }) => {
    const [newT] = useNewTranslation()
    const [formProps, setFormProps] = useState<NoneApproveFormValues>({
        comment: '',
    })
    const validation = yup.object({
        comment: yup
            .string()
            .nullable()
            .max(10000, ({ max }) =>
                newT(
                    'errorMessage.validation.enterLessThanCharacterLimit',
                    'Please enter less than {{max}} characters.',
                    {
                        max,
                    },
                ),
            )
            .required(
                newT('errorMessage.validation.enterRequestEditReason', 'Please enter a reason for the Partiposter'),
            ),
    })

    return (
        <Formik
            initialValues={{ comment: formProps.comment }}
            enableReinitialize={true}
            validationSchema={validation}
            onSubmit={(values: { comment: string | null }, actions) => {
                handleReject(values.comment)
                actions.setSubmitting(false)
            }}
        >
            {() => (
                <Form>
                    <Box
                        width="100%"
                        sx={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: theme.spacing.xs }}
                    >
                        <Text fontSize="1.2em" textAlign="center">
                            {newT(
                                'modalWindow.reasonForPartiposterRejectionTitle',
                                "The reason for this Partiposter's rejection is:",
                            )}
                        </Text>
                        <Inputs.TextArea
                            name="comment"
                            placeholder={newT('submission.review.reasonsForRequestEditSubtitle')}
                            minTextAreaHeight={80}
                            onChange={value => setFormProps({ comment: value })}
                            width="98%"
                        />
                        <Box width="90%" sx={{ margin: 'auto' }}>
                            <Text color={theme.colors.boulder} fontSize="0.75em" textAlign="center">
                                {newT(
                                    'submission.review.reviewRejectionComment',
                                    'We will be reviewing this rejection before the Partiposter is notified.',
                                )}
                            </Text>
                            <Text
                                color={theme.colors.boulder}
                                fontSize="0.75em"
                                textAlign="center"
                                mt={theme.spacing.xxxs}
                            >
                                {newT(
                                    'submission.review.reviewRejectionInstruction',
                                    'Once rejected, the Partiposter will be banned from resubmitting content to the campaign.',
                                )}
                            </Text>
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                        <Button width="50%" onClick={handleCancel}>
                            {newT('button.cancel')}
                        </Button>
                        <Button
                            width="50%"
                            type="submit"
                            bg={theme.colors.monza}
                            sx={{ borderRadius: '0.8em' }}
                            my={theme.spacing.xs}
                            textProps={{ color: theme.newColors.neutral50, fontSize: '0.8em', px: theme.spacing.s }}
                            disabled={!formProps.comment}
                            opacity={!formProps.comment ? 0.4 : 1}
                        >
                            {newT('button.reject')}
                        </Button>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}

export default RejectionForm
